// Web Audio API–based notification sounds. Zero assets, zero network.
// Three flavours: "bell", "train", "alarm". Also "off" silences the chime.

let ctx = null;
function getCtx() {
  if (!ctx) {
    try {
      // eslint-disable-next-line no-undef
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC) ctx = new AC();
    } catch { /* ignore */ }
  }
  // Resume if suspended after a user gesture
  if (ctx && ctx.state === "suspended") { try { ctx.resume(); } catch { /* ignore */ } }
  return ctx;
}

function envelope(gainNode, startTime, attack, decay, sustain, release, peak = 0.2) {
  gainNode.gain.cancelScheduledValues(startTime);
  gainNode.gain.setValueAtTime(0, startTime);
  gainNode.gain.linearRampToValueAtTime(peak, startTime + attack);
  gainNode.gain.linearRampToValueAtTime(peak * sustain, startTime + attack + decay);
  gainNode.gain.linearRampToValueAtTime(0, startTime + attack + decay + release);
}

function tone({ freq = 880, type = "sine", duration = 0.4, delay = 0, peak = 0.2 }) {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  osc.connect(g);
  g.connect(c.destination);
  const start = c.currentTime + delay;
  envelope(g, start, 0.01, 0.05, 0.6, duration, peak);
  osc.start(start);
  osc.stop(start + duration + 0.1);
}

// Classic doorbell: two quick ding-dong tones
function playBell() {
  tone({ freq: 988, type: "sine", duration: 0.45, delay: 0, peak: 0.22 });      // B5
  tone({ freq: 659, type: "sine", duration: 0.6, delay: 0.18, peak: 0.22 });    // E5
}

// Train horn: two chord hits (major sixth-ish), low + mid
function playTrain() {
  const c = getCtx();
  if (!c) return;
  const chord = (when) => {
    [196, 247, 294].forEach((f) => tone({ freq: f, type: "sawtooth", duration: 0.55, delay: when, peak: 0.12 }));
  };
  chord(0);
  chord(0.35);
}

// Alarm: three sharp beeps on square wave
function playAlarm() {
  for (let i = 0; i < 3; i++) {
    tone({ freq: 1046, type: "square", duration: 0.18, delay: i * 0.22, peak: 0.18 });
  }
}

export const SOUNDS = [
  { key: "bell", label: "Bjelle" },
  { key: "train", label: "Tog" },
  { key: "alarm", label: "Alarm" },
  { key: "off", label: "Av (stille)" },
];

export function playNotificationSound(key) {
  try {
    switch (key) {
      case "bell": return playBell();
      case "train": return playTrain();
      case "alarm": return playAlarm();
      case "off":
      default: return;
    }
  } catch { /* ignore */ }
}

const LS_KEY = "pb_notif_sound";
export function getStoredSound() {
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v && SOUNDS.some((s) => s.key === v)) return v;
  } catch { /* ignore */ }
  return "bell";
}

export function setStoredSound(key) {
  try { localStorage.setItem(LS_KEY, key); } catch { /* ignore */ }
}
